import CopyIcon from '../Icon/CopyIcon.js';
import __vue_component__ from './BreadcrumbItem.vue.js';
import __vue_component__$1 from '../CopyToClipboard/CopyToClipboard.vue.js';

//
var script = {
  name: 'Breadcrumbs',
  components: {
    BreadcrumbItem: __vue_component__,
    CopyIcon,
    CopyToClipboard: __vue_component__$1
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    copy: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      lastItemLink: undefined
    };
  },

  mounted() {
    const links = this.$el.querySelectorAll('a');
    this.lastItemLink = links[links.length - 1].getAttribute('href');
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Breadcrumbs/Breadcrumbs.vue_rollup-plugin-vue=script.js